import { useLayoutEffect, useRef } from "react";

// Shrinks font-size only when the text overflows its box; otherwise keeps the CSS size.
export const useFitText = (text) => {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    let lastWidth = -1;
    const fit = () => {
      if (el.clientWidth === lastWidth) return;
      lastWidth = el.clientWidth;
      el.style.fontSize = "";
      const { scrollWidth: sw, clientWidth: cw } = el;
      if (cw > 0 && sw > cw) {
        const base = parseFloat(getComputedStyle(el).fontSize);
        el.style.fontSize = `${Math.floor(((base * cw) / sw) * 0.98 * 10) / 10}px`;
      }
    };
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(el);
    return () => ro.disconnect();
  }, [text]);
  return ref;
};
